export default {
  rfm: {
    1: 'Upper Crust',
    2: 'Affluentials',
    3: 'Suburban Sprawl',
    4: 'Blue-Chip Blues',
    5: 'Urban cores',
  },
  colors: ['#3E72D6', '#DD4500', '#FCA400', '#229F00', '#A112A7', '#FF1493', '#FF8C00', '#FF8C00', '#FFFF00', '#FFDEAD'],
  chart_types: [
    { value: 'BarChart', label: 'Bar Chart' },
    { value: 'PieChart', label: 'Pie Chart' },
  ],
};
